import { motion } from "framer-motion";
import { BsArrowUp } from "react-icons/bs";

import { variants } from "../../utils/animations";
import "./styles.css";

const Footer = () => {
  return (
    <motion.div
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true }}
      variants={variants}
      className='footer__container'
    >
      <div>
        {/* <a
          className='footer__resume'
          href='mailto:moubaniroychoudhury@gmail.com?subject=Request%20for%20CV&body=Hi%20Moubani%2C%0A%0AI%20would%20like%20to%20learn%20more%20about%20your%20experience.%20Could%20you%20please%20share%20your%20CV%3F%0A%0AThanks'
        >
          Resume
        </a> */}
        <a
          className='noLink'
          style={{ color: "var(--dark)" }}
          href='mailto:storiesbymoubani@gmail.com'
        >
          Contact Me
        </a>
        <button onClick={() => window.scrollTo(0, 0)}>
          Go to top
          <BsArrowUp />
        </button>
      </div>
      <p style={{ color: "var(--grey)" }}>
        Copyrights reserved &copy; {new Date().getFullYear()} By Moubani
      </p>
    </motion.div>
  );
};

export default Footer;
